import {CloudUploadOutlined, PieChartOutlined, TeamOutlined, CheckCircleOutlined} from "@ant-design/icons";
import {Image, Layout, Menu} from "antd";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Logo from "../assets/logo-white.png";
import Api from "../common/Api";

const {Sider} = Layout;

interface Props {
    selectedKeys: Array<string>;
    defaultKeys: string;
}

const ADMIN_STATE = [
    "Admin",
    "State"
];

const Sidebar = ({selectedKeys, defaultKeys}: Props) => {
    const navigate = useNavigate();
    const [group, setGroup] = useState("")

    useEffect(() => {
        (async () => {
            const {data} = await Api.usersManagement.isStateOrAdminUser();
            setGroup(data);
        })()
    }, [])

    return (
        <Sider collapsible collapsedWidth={0} breakpoint="md">
            <div className="logo-trigger">
                <Image
                    preview={false}
                    width={"100%"}
                    src={Logo}
                /></div>
            <Menu defaultSelectedKeys={[defaultKeys]} theme="dark" mode="inline" selectedKeys={selectedKeys}>
                <Menu.Item key={defaultKeys} icon={<PieChartOutlined style={{fontSize: '1.4em'}}/>}
                           onClick={() => navigate('/', {replace: true})}>
                    Dashboard
                </Menu.Item>
                <Menu.Item key={"upload"} icon={<CloudUploadOutlined style={{fontSize: '1.4em'}}/>}
                           onClick={() => navigate('/upload', {replace: true})}>
                    Upload
                </Menu.Item>

                {ADMIN_STATE.includes(group) && (<>
                    <Menu.Item key={"vins-validation"} icon={<CheckCircleOutlined style={{fontSize: '1.4em'}}/>}
                               onClick={() => navigate('/vins-validation', {replace: true})}>
                        Duplicate VIN Check
                    </Menu.Item>
                </>)}

                {(group === ADMIN_STATE[0]) && (<>
                    <Menu.Item key={"admin"} icon={<TeamOutlined style={{fontSize: '1.4em'}}/>}
                               onClick={() => navigate('/admin', {replace: true})}>
                        Administration
                    </Menu.Item>
                </>)}

            </Menu>
        </Sider>
    )
}

export default Sidebar;